/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Firstlanguage1Inputs */

const en__field_firstlanguage1 = /** @type {(inputs: _Field_Firstlanguage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First language`)
};

/**
* | output |
* | --- |
* | "First language" |
*
* @param {_Field_Firstlanguage1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_firstlanguage1 = /** @type {((inputs?: _Field_Firstlanguage1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Firstlanguage1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_firstlanguage1(inputs)
});
export { _field_firstlanguage1 as "_field_firstLanguage" }